import { useEffect, useState } from 'react';

const FALLBACK = 'Europe/Moscow';
let cached: Promise<string> | null = null;
let resolved: string = FALLBACK;

function loadBusinessTimeZone(): Promise<string> {
    if (!cached) {
        cached = fetch('/api/app-info')
            .then(r => (r.ok ? r.json() : null))
            .then(json => {
                const tz = json?.data?.businessTimeZone;
                return typeof tz === 'string' && tz ? tz : FALLBACK; // Minor: runtime-guard the type
            })
            .catch(() => FALLBACK);
        cached.then(tz => { resolved = tz; });
    }
    return cached;
}

// Non-reactive accessor for non-component render contexts (e.g. operation-report renderers,
// which are plain functions, not components, so hooks are unavailable). Returns the last
// resolved business zone, or the fallback until /api/app-info has loaded.
export function getCachedBusinessTimeZone(): string {
    void loadBusinessTimeZone();
    return resolved;
}

export function useBusinessTimeZone(): string {
    const [timeZone, setTimeZone] = useState(resolved);
    useEffect(() => {
        let active = true;
        loadBusinessTimeZone().then(tz => { if (active) setTimeZone(tz); });
        return () => { active = false; };
    }, []);
    return timeZone;
}
